<template>
   <LoadingPage v-if="isLoading"></LoadingPage>

         <div class="modal-body px-4">

            <div class="row pb-1">
               <h3 class="modal-title"><strong> {{ lead.organisation }}</strong></h3>
            </div>

            <form class="row g-0" style="gap: 0.5rem">

               
               <FileUploader ref="proposalFileRef" :id="'proposalFile'" @fileListChange="handleFileUpload"
                     key="proposalFile" :acceptedFileType="'pdf'"/>
               <label class="text-end">
                  <span class="text-danger">*</span><i class="small">Please upload pdf file formats only.</i>
               </label>

               <div class="form-floating">
                  <textarea class="form-control" id="proposalNote" v-model.trim="proposalNote"
                     placeholder="Write additional information (optional)" style="height: 100px"></textarea>
                  <label for="proposalNote" class="text-muted">Write additional information (optional)</label>
               </div>

               <div class="mb-4 d-row d-flex align-items-center justify-content-end" style="gap: 1rem">
                  <div>
                     <div class="form-check">
                        <input class="form-check-input" type="checkbox" :value="true" id="isProposalSent" v-model.trim="isProposalSent">
                        <label class="form-check-label pt-1" for="isProposalSent"><strong>Proposal sent to client?</strong></label>
                     </div>
                  </div>

                  <div class="text-end">
                     <button type="button" class="btn btn-info text-light" @click="uploadProposal(lead.id)" :disabled="disableFormButton()"> {{isUploading ? 'Uploading...' : 'Upload'}} </button>
                  </div>
               </div>
               
            </form>

            <div class="row px-3" v-for="leadProposal in leadProposals" :key="leadProposal.id">

               <div class="card">

                  <div class="card-body">

                     <div>

                        <div class="d-row d-flex" style="gap: 0.2rem">
                           <div v-if="leadProposal.user"> {{ leadProposal.user.firstName + " " + leadProposal.user.lastName }}</div>
                           <p class="text-end" style="font-size:10px" :title="formatDate(leadProposal.created_at, 'full')">
                              {{ formatDate(leadProposal.created_at) }}
                           </p>
                           

                           <div class="px-4" v-if="leadProposal.proposals.length > 0">

                              <p v-if="leadProposal.proposal_note != ''">
                                 <i>Note: {{ leadProposal.proposal_note }}</i>
                              </p>
                              <p class="form-label"><strong>Uploaded proposal/s:</strong></p>
                              
                              <div class="ps-3 pb-2" v-for="file in leadProposal.proposals" :key="file.id" title="Click to download" >
                                 <a href="#" @click="downloadFile(file)">{{ file.file_name }}</a>
                              </div>
                           </div>


                           <div class="form-check">
                              <input class="form-check-input" type="checkbox" :value="true" id="isLeadProposalSent" v-model.trim="leadProposal.is_sent" @change="updateProposalSent(leadProposal)">
                              <label v-if="!leadProposal.is_sent" class="form-check-label pt-1 small text-end" for="isLeadProposalSent"><strong>Proposal sent?</strong></label>
                              <label v-if="leadProposal.is_sent" class="small text-end" style="color:#00A54F">
                                 <i>Proposal sent to client.</i>
                              </label>
                           </div>
                           
                        </div>

                     </div>
                     
                  </div>

               </div>

               <hr>

            </div>

         </div>

         <!-- LOADING SCREEN -->
         <div v-if="isUploading" class="loading" :class="{'d-none' : !isUploading}">
            <div class="row p-2 justify-content-center" style="background-color: #fff;">

               <div class="text-center mb-2" >
                  <div class="mb-2"><strong>Uploading</strong></div>
                  <div>Please wait...</div>
               </div>
            
               <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
               </div>
            </div>
         </div>
         <!-- END -- LOADING SCREEN -->   
</template>

<script>
import moment from "moment";
import { Modal } from 'bootstrap';
import { toTitleCase } from '@/plugins/helper.js'
import FileUploader from '@/components/FileUploader.vue';
import LoadingPage from '@/components/Utilities/vertex-loading.vue'

export default {

   components: {
      FileUploader,
      LoadingPage
   },

   props: {
      isProposalSentStatus: {
         type: Boolean,
      }
   },

   emits: ['onUpdate', 'onClose'],

	data() {
		return {
         lead: {
            id: '',
            organisation: '',
         },
         leadProposals: [],
         leadProposal: {
            id: '',
            proposalNote: '',
            isSent: false,
            lead: '',
            createdBy: '',
            createdAt: '',
            files: [],
         },
         proposalNote: '',
         isProposalSent: false,
			currentDate: null,
         isUpdatingStatusToSent: false,
         totalProposals: 0,
         isUploading: false,
         isLoading: false,
		}
	},

   computed: {
      isUpdatingStatus() {
         return this.isProposalSentStatus
      },

   },

   watch: {
      isUpdatingStatus() {
         if (this.isProposalSentStatus) {
            this.isUpdatingStatusToSent = true
            this.isProposalSent = true
         }
      },
     
   },

	methods: {
		init(id) {
			this.currentDate = moment(new Date()).format("DD-MMM-YYYY");
         this.getLead(id)
         this.getLeadProposals(id)
		},

      showModal(e){
         Modal.getOrCreateInstance(e).show() // Returns a Bootstrap modal instance
      },

      formatDate(date, type){
         if (type == "full") {
            return moment(date).format("DD-MMM-YYYY h:mm A")
         } else {
            return moment(date).format("DD-MMM-YYYY")
         }
         
      },

      formatToTitleCase(str) {
         return toTitleCase(str)
      },

      resetForm() {
         // this.leadProposal.proposalNote = ''
         this.$refs.proposalFileRef.resetForm()
         this.proposalNote = ''
         this.isProposalSent = false
         this.isUpdatingStatusToSent = false
         this.leadProposal.files = []
         this.isUploading = false

         this.$emit('onClose')
      },

      async getLead(id) {

         await this.$axios.get("/leads/"+id)
         .then((response) => {
            this.lead.id = response.data.lead.id
            this.lead.organisation = response.data.lead.organisation_name
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      // Call get users api in Auth
      async getAuthUser(id, index){
         await this.$axios_auth.get("/users/"+id)
         .then((response) => {

            if (response.data.user) {
               let user = {
                  firstName: response.data.user.first_name,
                  lastName: response.data.user.last_name
               }

               this.leadProposals[index].user = user
            }
            
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      // loop through the notes and get user 
      getUser(){
         for (let i in this.leadProposals) {
            let userId = this.leadProposals[i].created_by

           this.getAuthUser(userId, i)
         }
      },

      async getLeadProposals(id) {
         this.isLoading = true
         await this.$axios.get("/leads/"+id+"/proposals")
         .then((response) => {
            this.leadProposals = response.data.items
            this.totalProposals = response.data.total_items
            this.getUser()
            this.isLoading = false
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
            this.isLoading = false
         })
         
      },

      // used by other component to retrieve number of proposals uploaded
      async hasUploadedProposal(id){
         
         await this.getLeadProposals(id)
         
         return this.totalProposals
      },

      async uploadProposal(id){

         this.isUploading = true
         
         let proposal = {
            proposal_note : this.proposalNote,
            is_sent : this.isProposalSent,
            lead_id : id,
         }

         proposal.proposals = []
         this.leadProposal.files.forEach((s) => {
            proposal.proposals.push({ 
               encoded_file : s.encoded,
               file_name : s.name,
               file_extension: s.extension,
            })
         })
         
         await this.$axios.post("/leads/"+id+"/proposals", proposal)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.resetForm();

               this.getLeadProposals(id)

               this.$emit('onUpdate')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

         this.isUploading = false
         
      },

      async updateProposalSent(proposal) {
        
         let data = {
            is_sent : proposal.is_sent,
         }

         await this.$axios.put("/leads/"+proposal.lead_id+"/proposals/"+proposal.id, data)
         .then((response) => {
            this.$toast.success(response.data.message)
            this.getLeadProposals(proposal.lead_id)
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      },

      handleFileUpload({type, files}) {
         
         if (type == "proposalFile"){
            this.leadProposal.files = files
         }

      },

      disableFormButton(){
         return this.leadProposal.files.length < 1 || this.isUploading
      },

      async downloadFile(data) {
         await this.$axios.get("/leads/"+this.lead.id+"/proposals/"+data.lead_proposal_id+"/files/"+data.id, {
            responseType: 'blob',
         })
         .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            // fileName = this.lead.organisation_name + "_" + testType + "_" + fileName
            link.href = url
            link.setAttribute('download', data.file_name)
            link.click()
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
         
      }
	},
};

</script>

<style scoped>
.loading {
   position: absolute;
   /* top: 0; */
   /* left: 0;
   right: 0;
   bottom: 0; */
   z-index: 999;
   background-color: rgb(0,0,0,0.2);
   height: 100%;
   width: 100%;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

</style>